module.exports =
  require("../../../lib").grpc.gateway.protoc_gen_openapiv2.options;
